import axios from '@axios'

const getInitialState = () => ({
  contracts: [],
  filters: { storeId: null, skuId: null },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    SET_CONTRACTS(state, contracts) {
      state.contracts = contracts
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { filters, contracts } = getInitialState()
      state.filters = filters
      state.contracts = contracts
    },
  },

  actions: {
    async fetchContracts({ commit, state }) {
      const { data } = await axios.get('/api/skus/cost-contract-suppliers', {
        params: {
          storeId: state.filters.storeId,
          skuId: state.filters.skuId,
        },
      })

      commit('SET_CONTRACTS', data)
    },

    async createContract(context, payload) {
      const { data } = await axios.post('/api/skus/cost-contract-suppliers', payload)
      return data
    },

    async updateContract(context, { id, payload }) {
      const { data } = await axios.put(`/api/skus/cost-contract-suppliers/${id}`, payload)
      return data
    },

    async deleteContract(context, id) {
      const { data } = await axios.delete(`/api/skus/cost-contract-suppliers/${id}`)
      return data
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
